<template>
  <div class="row">
    <div class="col-md-12">
      <form v-on:submit.prevent="submit">
        <buttons top />
      </form>
    </div>
    <div class="col-md-12">
      <h4>Capital Provider</h4>
      <p>Please enter the information below.</p>
      <small><i>*required</i></small>
      <hr />
      <form v-on:submit.prevent="submit">
        <div class="row">
          <div class="form-group col-md-6">
            <div class="form-group input-group">
              <span style="background: white;" class="input-group-addon"
                ><span>Name*</span></span
              >
              <input
                class="form-control"
                :value="
                  $store.getters.getEditedProviderValueByKeyChain(['name'])
                "
                @input="setName"
                type="username"
                placeholder="Provider Name"
                required
              />
            </div>
          </div>

          <div class="form-group col-md-6">
            <div class="form-group input-group">
              <span style="background: white;" class="input-group-addon"
                ><span>Year Founded*</span></span
              >
              <select
                style="margin: 0px; border-top-left-radius: 0px;"
                class="form-control"
                :value="
                  $store.getters.getEditedProviderValueByKeyChain([
                    'year_founded'
                  ])
                "
                @input="setDate"
                required
              >
                <option :value="null">Select year</option>
                <option v-for="year in yearRange">{{ year }}</option>
              </select>
            </div>
          </div>
          <div class="form-group col-md-12">
            <div class="form-group input-group">
              <span style="background: white;" class="input-group-addon"
                ><span>URL*</span></span
              >
              <input
                class="form-control"
                :value="
                  $store.getters.getEditedProviderValueByKeyChain(['url'])
                "
                @input="setUrl"
                type="url"
                oninvalid="setCustomValidity('Enter a valid URL beginning with http or https.')"
                placeholder="https://example.com"
                required
              />
            </div>
          </div>

          <div class="form-group col-md-12">
            <span>Description*</span>
            <small><i>(200 - 1000 characters)</i></small>
            <div class="form-group input-group" style="width: 100%;">
              <textarea
                style="border-radius: 5px;"
                class="form-control"
                :value="
                  $store.getters.getEditedProviderValueByKeyChain([
                    'description'
                  ])
                "
                @input="setDesc"
                type="text"
                rows="7"
                maxlength="10000"
                minlength="200"
                required
              />
            </div>
          </div>

          <div class="form-group col-md-6">
            <div class="form-group input-group">
              <span style="background: white;" class="input-group-addon"
                ><span>Email</span></span
              >
              <input
                class="form-control"
                :value="
                  $store.getters.getEditedProviderValueByKeyChain(['email'])
                "
                @input="setEmail"
                type="email"
                placeholder="Email Address"
              />
            </div>
          </div>

          <div class="form-group col-md-6">
            <div class="form-group input-group">
              <span style="background: white;" class="input-group-addon"
                ><span>Phone Number</span></span
              >
              <input
                class="form-control"
                :value="
                  $store.getters.getEditedProviderValueByKeyChain([
                    'phone_number'
                  ])
                "
                @input="setPhoneNumber"
                type="tel"
                pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                placeholder="Phone Number"
              />
            </div>
          </div>

          <img
            :v-if="$store.getters.getEditedProviderValueByKeyChain(['logo'])"
            :src="$store.getters.getEditedProviderValueByKeyChain(['logo'])"
          />
          <filestack :apikey="apikey" :options="options" @success="onSuccess">
            <button class="btn btn-create">
              Upload logo
            </button>
          </filestack>
        </div>
        <buttons />
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import textInput from "../elements/textInput.vue";
import buttons from "../elements/buttons.vue";
import utils from "./utils.js";
import Filestack, { client } from "filestack-vue";

export default {
  name: "provider-page",
  data: function() {
    return {
      apikey: "AfgNVUvKyT1uyldNwIASmz",
      options: {}
    };
  },
  components: {
    textInput: textInput,
    buttons: buttons,
    filestack: Filestack
  },
  computed: {
    ...mapGetters({
      editedProvider: "getEditedProviderValueByKeyChain",
      next: "next",
      prev: "prev",
      noErrors: "noErrors",
      verifySync: "verifySync",
      isCreateMode: "isCreateMode"
    }),
    yearRange: function() {
      return utils.yearRange();
    }
  },
  methods: {
    onSuccess(event) {
      this.setLogo(event.filesUploaded[0].url);
    },
    submit: function() {
      utils.post(this);
    },
    setName(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["name"]
      });
    },
    setEmail(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["email"]
      });
    },
    setPhoneNumber(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["phone_number"]
      });
    },
    setDesc(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["description"]
      });
    },
    setUrl(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["url"]
      });
    },
    setLogo(event) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: event,
        keyChain: ["logo"]
      });
    },
    setDate(editedData) {
      this.$store.commit("setEditedProviderByKeyChain", {
        data: editedData.target.value,
        keyChain: ["year_founded"]
      });
    }
  },
  beforeRouteLeave: function(to, from, next) {
    var self = this;
    utils.beforeRouteLeave(self, to, from, next);
  }
};
</script>

<style scoped>
.bottom-container {
  position: fixed;
  left: 0;
  bottom: 0px;
  width: 100%;
  color: white;
  text-align: center;
  z-index: 9999;
}

.nav-button {
  display: inline-block;
  padding: 5px 15px 5px 15px;
  margin-left: 13px;
  margin-right: 13px;
  border: solid 2px black;
  border-radius: 10px;
  background-color: white;
  -webkit-transition-duration: 0.4s;
  transition-duration: 0.4s;
}

.nav-button:hover {
  background-color: grey;
}

.left-button {
  float: left;
}

.right-button {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/providerPage.vue